(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6651],{

/***/ 28151:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-started",
      function () {
        return __webpack_require__(36435);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ getting_started; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@c9566f0d83afefd50891e539ddcd310845ce514c_@emotion+react_fkvzwtw37n666fdzuv4pangbii/node_modules/@blackbird/ui-base/dist/es/link/index.js + 2 modules
var es_link = __webpack_require__(88457);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(6203);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(79064);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(27908);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.13.5_@emotion+react@11.11.1_@emotion+styled@11.11.0_@types+react@17.0.62_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(1827);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.6_@emotion+react@11.11.1_@emotion+server@11.11.0_react@17.0.2/node_modules/tss-react/esm/mui.js
var mui = __webpack_require__(71601);
;// CONCATENATED MODULE: ./views/getting-started/getting-started-page.tsx









var useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        root: {
            display: "flex",
            justifyContent: "center",
            flexGrow: 1,
            height: "100%"
        },
        grid: {
            alignSelf: "center",
            textAlign: "left"
        },
        getStartedImage: {
            width: "100%",
            borderRadius: "10px"
        },
        button: {
            marginTop: theme.spacing(2)
        }
    };
});
function GettingStartedPage() {
    var classes = useStyles().classes;
    var t = (0,useTranslation/* useTranslation */.$)([
        "shared",
        "gettingStarted"
    ]).t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            className: classes.grid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: classes.getStartedImage,
                            src: "/images/getting-started.png"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 6,
                    className: classes.grid,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                align: "left",
                                children: t([
                                    "gettingStarted:liveDataAnywhere"
                                ], {
                                    defaultValue: "Live data, anywhere"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle1",
                                align: "left",
                                children: t([
                                    "gettingStarted:letsUsGuideYou"
                                ], {
                                    defaultValue: "First time using Factbird? Let us guide you through it."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                                href: {
                                    pathname: "/getting-started/learn"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    color: "primary",
                                    className: classes.button,
                                    children: t([
                                        "gettingStarted:getStarted"
                                    ], {
                                        defaultValue: "Get Started"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/getting-started/index.tsx


var GettingStarted = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GettingStartedPage, {});
};
var __N_SSG = true;
/* harmony default export */ var getting_started = (GettingStarted);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(28151); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);